<script lang="ts">
    export let title: string = '';
    export let open: boolean = false;

</script>
<div class="accordion" class:active={open}>
    <div class="accordion-header box-b border-bottom py-iii" on:click={()=> open = !open}>
        <div>
            <strong style="font-size: 14px">{title}</strong>
        </div>
        <div>
            <img class="chevron" height="20" src="/static/storefront/pix/icons/chevron-gray.svg" alt="chevron">
        </div>
    </div>
    <div class="accordion-panel py-1">
        <slot>

        </slot>
    </div>
</div>